/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Imageviewer_Footer_Help_LargeInputs */



/**
* | output |
* | --- |
* | "Use +/- to zoom • R to rotate • Click and drag to pan when zoomed • Ctrl+Scroll to zoom" |
*
* @param {Spaces_Imageviewer_Footer_Help_LargeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_imageviewer_footer_help_large = /** @type {((inputs?: Spaces_Imageviewer_Footer_Help_LargeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Imageviewer_Footer_Help_LargeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwende +/- zum Zoomen • R zum Drehen • Klicken und Ziehen zum Verschieben beim Zoomen • Strg+Scroll zum Zoomen")
	return /** @type {LocalizedString} */ ("Use +/- to zoom • R to rotate • Click and drag to pan when zoomed • Ctrl+Scroll to zoom")
});